import "./styles/Navigation.css";
import MenuLinks from "./MenuLinks";

const Navigation = () => {
  return (
    <nav className="navigation">
      <MenuLinks />
    </nav>
  );
};

export default Navigation;
